<template>
  <!--콘텐츠 영역-->

  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">MRO</h3>
      </div>
      <div class="txt">
        <h4 class="fs-50 fMTP-EB pdb30" style="color: #100249;">INNOVATIVE PROCUREMENT</h4>
        <p class="lh30 fNS-B pdb30">
          "고객 가치 창출과 공급사와의 협력을 통한 경쟁력 강화를 이루어낼
          <br />새로운 Innovative Procurement 시대를 열어 가겠습니다!”.
        </p>
        <p class="pdt50 pdb50">
          <img :src="require('./../../assets/img/sub/02/0202_01.png')" />
        </p>
        <p class="lh30 fNS-B pdt30">
          MP(Market place)는 전문적이고 체계적인 구매방법론을 통해 신속하고 안정적인 TOC 관점의 효율적 구매실현을 위한
          페럼인프라의 새로운 구매혁신 서비스 입니다.
        </p>
        <div class="pdt40 pdb20">
          <a href="http://mp.ferruminfra.co.kr/login.jsp" target="_blank">
            <button class="btn_link type01">MP 바로가기</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "Mro.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub02/Mro.vue